/**
 * 监控数据Hooks
 * Feature: vanadium-industry-map
 * 验证需求：11.5
 */
import { useQuery } from '@tanstack/react-query';
import {
  getDataSourcesStatus,
  getQualityReports,
  getQualitySummary,
  getSystemHealth,
  type DataSourcesResponse,
  type QualityReportsResponse,
  type QualitySummaryResponse,
  type SystemHealthResponse,
} from '../api/monitoring';

/**
 * 获取数据源状态
 */
export const useDataSourcesStatus = () => {
  return useQuery<DataSourcesResponse>({
    queryKey: ['monitoring', 'data-sources'],
    queryFn: getDataSourcesStatus,
    refetchInterval: 60000, // 每分钟刷新一次
  });
};

/**
 * 获取数据质量报告
 */
export const useQualityReports = (params?: {
  start_date?: string;
  end_date?: string;
  data_type?: string;
  min_score?: number;
  skip?: number;
  limit?: number;
}) => {
  return useQuery<QualityReportsResponse>({
    queryKey: ['monitoring', 'quality-reports', params],
    queryFn: () => getQualityReports(params),
  });
};

/**
 * 获取数据质量汇总
 */
export const useQualitySummary = (days: number = 7) => {
  return useQuery<QualitySummaryResponse>({
    queryKey: ['monitoring', 'quality-summary', days],
    queryFn: () => getQualitySummary(days),
    refetchInterval: 300000, // 每5分钟刷新一次
  });
};

/**
 * 获取系统健康状态
 */
export const useSystemHealth = () => {
  return useQuery<SystemHealthResponse>({
    queryKey: ['monitoring', 'system-health'],
    queryFn: getSystemHealth,
    refetchInterval: 30000, // 每30秒刷新一次
  });
};
